






























import { Component, Prop, Mixins } from 'vue-property-decorator';
import ConversationData from '@/ts/ConversationData';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import ParticipantIcon from '@/components/Media/ParticipantIcon.vue';
import MessageData from '@/ts/MessageData';

@Component({
    components: {
        ParticipantIcon,
    },
})
export default class StaffConversations extends Mixins(DeviceMethods) {
    @Prop() public conversationData!: ConversationData;
    @Prop() public mainClass!: string;
    @Prop() public isActive!: boolean;

    constructor() {
        super();
    }

    get conversationHeader(): string {
        if (this.conversationData.isUnderComposition) {
            return 'New conversation';
        }

        return this.conversationData.recipientNames;
    }

    public sender(message: MessageData) {
        return message !== null
            ? this.$store.getters['User/getCacheUser'](message.authorId)
            : '';
    }

    public author(authorId: number) {
        return this.$store.getters['User/getCacheUser'](authorId);
    }

    public propertyAddress(propertyId: number) {
        const property = this.$store.getters['Properties/getProperty'](propertyId);
        return property ? property.address : '';
    }

    get dataLoaded(): boolean {
        return (
            this.conversationData !== null
         && this.conversationData.participants !== null
         && this.conversationData.participants.constructor === Array
         && this.conversationData.participants.length > 0
         && this.conversationData.messages !== null
        );
    }
}
